import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from "react";
import { OnlineMenuModel } from "../api/model/response/OnlineMenuResponseModel";
import { LanguageModel } from "../api/model/response/LanguageModel";
import { CompanyInfoModel } from "../api/model/response/CompanyInfoModel";

interface OrderModel {
  id: string;
  name: string;
  orderPrice: number;
  photoUrl: string;
  quantity: number;
  type: "food" | "subfood";
}

const dataInitial = {} as OnlineMenuModel;
const dataInitialLang = [] as LanguageModel[];
const dataInitialCompany = {} as CompanyInfoModel;
const dataInitialOrders = JSON.parse(localStorage.getItem("orders") ?? "[]");
const dataInitialIsPageViewed = false as boolean;
const dataIsCartActive = false as boolean;
const dataUtag = "" as string;

interface UserContextProps {
  currentOnlineMenu: OnlineMenuModel;
  setCurrentOnlineMenu: Dispatch<SetStateAction<OnlineMenuModel>>;
  currentLanguagesList: LanguageModel[];
  setCurrentLanguagesList: Dispatch<SetStateAction<LanguageModel[]>>;
  currentCompanyInfo: CompanyInfoModel;
  setCurrentCompanyInfo: Dispatch<SetStateAction<CompanyInfoModel>>;
  currentIsPageViewedInfo: boolean;
  setIsPageViewedInfo: Dispatch<SetStateAction<boolean>>;
  isCartActive: boolean;
  setIsCartActive: Dispatch<SetStateAction<boolean>>;
  orders: OrderModel[];
  setOrders: Dispatch<SetStateAction<OrderModel[]>>;
  utag: string;
  setUtag: Dispatch<SetStateAction<string>>;
}

export const UserContext = createContext<UserContextProps>({
  currentOnlineMenu: dataInitial,
  currentCompanyInfo: dataInitialCompany,
  currentLanguagesList: dataInitialLang,
  currentIsPageViewedInfo: dataInitialIsPageViewed,
  orders: dataInitialOrders,
  isCartActive: dataIsCartActive,
  utag: dataUtag,
} as UserContextProps);

export const UserProvider = (props: { children: ReactNode }) => {
  const [currentMenu, setCurrentOnlineMenu] =
    useState<OnlineMenuModel>(dataInitial);
  const [currentLangs, setCurrentLanguages] =
    useState<LanguageModel[]>(dataInitialLang);
  const [currentCompany, setCurrentCompany] =
    useState<CompanyInfoModel>(dataInitialCompany);
  const [currentIsPageViewed, setIsPageViewed] = useState<boolean>(
    dataInitialIsPageViewed
  );
  const [orders, setOrders] = useState<OrderModel[]>([]);
  const [isCartActive, setIsCartActive] = useState<boolean>(dataIsCartActive);
  const [utag, setUtag] = useState<string>(dataUtag);

  return (
    <UserContext.Provider
      value={{
        currentCompanyInfo: currentCompany,
        currentOnlineMenu: currentMenu,
        currentLanguagesList: currentLangs,
        currentIsPageViewedInfo: currentIsPageViewed,
        setIsPageViewedInfo: setIsPageViewed,
        setCurrentOnlineMenu: setCurrentOnlineMenu,
        setCurrentCompanyInfo: setCurrentCompany,
        setCurrentLanguagesList: setCurrentLanguages,
        orders: orders,
        setOrders: setOrders,
        isCartActive: isCartActive,
        setIsCartActive: setIsCartActive,
        utag: utag,
        setUtag: setUtag,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export const useUserContext = () => useContext(UserContext);
